import type { ProductApiItem } from '@/app/lib/api/types-api'

/**
 * Descarta los eventos marcados explícitamente como no visibles/no publicados
 * (`visible: false` o `published: false`). El resto pasa, incluidos los que no
 * traen ninguno de los dos campos (ausentes en el resto de listados que
 * reutilizan `ProductApiItem` — solo el payload de `Agenda` los trae).
 *
 * FR-007 (specs/042-modulo-agenda-cms/spec.md); data-model.md §2. Se aplica
 * tanto a la carga inicial del módulo (`Agenda.tsx`) como a cada respuesta de
 * cambio de día (`AgendaClient.tsx`) para que ambas rutas de datos apliquen la
 * misma regla.
 */
export function filterVisibleEvents(events: ProductApiItem[]): ProductApiItem[] {
  return events.filter((event) => event.visible !== false && event.published !== false)
}
